/** leads/UploadAnomalies.tsx — 업로드 특이사항 검토 모달 (덮지 않고 물어봅니다) */
import React from 'react';
import type { UploadAnomaly } from './types';

interface Props { anomalies: UploadAnomaly[]; source: string; onClose: () => void }

export default function UploadAnomalies({ anomalies, source, onClose }: Props) {
  return (
    <div className="ld-modal-bg ld-root" onClick={onClose}>
      <div className="ld-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ld-modal-h">
          <div><span>업로드 특이사항 {anomalies.length}건</span><span className="pm-sub">{source} — 기존 값과 다른 값이 들어왔습니다. <b>자동으로 덮지 않았습니다.</b></span></div>
          <button className="ld-btn" onClick={onClose}>닫기</button>
        </div>
        <div className="ld-modal-b">
          <table className="ld-table">
            <thead><tr><th>업체명</th><th>유효시작</th><th>항목</th><th>기존 (유지됨)</th><th>새 파일 값</th></tr></thead>
            <tbody>
              {anomalies.map((a, i) => (
                <tr key={i}>
                  <td><b>{a.corp_name}</b></td>
                  <td style={{ fontVariantNumeric: 'tabular-nums' }}>{String(a.venture_from).slice(0, 10)}</td>
                  <td>{a.field}</td>
                  <td style={{ color: '#16A34A', fontVariantNumeric: 'tabular-nums' }}>{a.existing}</td>
                  <td style={{ color: '#B45309', fontVariantNumeric: 'tabular-nums' }}>{a.incoming}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="pm-preview" style={{ marginTop: 12 }}>
            <b>처리 안내</b>
            <span style={{ fontSize: 12 }}>어느 쪽이 맞는지 확인 후: 법인번호가 새 값이 맞으면 해당 후보를 선택해 [법인번호만 조회]로 공식 재확인 · 종료일 차이는 재확인(연장) 가능성 — 원본 파일 출처 연도를 대조하세요. 시스템은 항상 기존 값을 유지합니다.</span>
          </div>
        </div>
        <div className="ld-modal-f"><button className="ld-btn pri" onClick={onClose}>확인</button></div>
      </div>
    </div>
  );
}
